import React from 'react';
import { newsArticles } from '../../data/news';
import CyberNewsListTemplate from './CyberNewsListTemplate';

const CyberNewsQuantumList: React.FC = () => {
  return <CyberNewsListTemplate 
    category="quantique"
    title="Quantique"
    description="Les avancées quantiques qui redéfinissent la sécurité numérique"
  />;
};

export default CyberNewsQuantumList; 